import axiosNewApi from "../config/axiosNewApi";

const handleError = (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 404:
        throw new Error("Cart not found");
      case 500:
        throw new Error("Server error. Please try again later.");
      default:
        throw new Error("An unexpected error occurred");
    }
  } else {
    throw new Error("An unexpected error occurred");
  }
};

export const fetchCarts = async () => {
  try {
    const { data, status } = await axiosNewApi.get("mobile/carts", {
      withCredentials: true,
    });

    if (status === 200) {
      return data;
    } else {
      throw new Error("Cart data not found");
    }
  } catch (error) {
    handleError(error);
  }
};

export const addCartItem = async (products) => {
  try {
    if (!products || !Array.isArray(products) || products.length === 0) {
      throw new Error("No data provided");
    }
    const { data, status } = await axiosNewApi.post(
      "mobile/carts/filter",

      {
        products,
      },
      { withCredentials: true }
    );
    if (status === 200) {
      return data;
    } else {
      throw new Error("Error on addition");
    }
  } catch (error) {
    handleError(error);
  }
};

export const updateCartItem = async (quantity, id) => {
  try {
    if (!id || quantity === undefined || quantity === null) {
      throw new Error("No data provided");
    }
    if (typeof quantity !== "number") {
      throw new Error("Quantity must be a number");
    }

    const { data, status } = await axiosNewApi.put(
      `mobile/carts/filter-quantity/${id}`,

      {
        quantity,
      },
      { withCredentials: true }
    );

    if (status === 200) {
      return data;
    } else {
      throw new Error("Error on updating");
    }
  } catch (error) {
    handleError(error);
  }
};

export const deleteCartItem = async (id) => {
  try {
    if (!id) {
      throw new Error("No data provided");
    }

    const { data, status } = await axiosNewApi.delete(`mobile/carts/filter/${id}`, {
      withCredentials: true,
    });

    if (status === 200) {
      return data;
    } else {
      throw new Error("Error on deletion");
    }
  } catch (error) {
    handleError(error);
  }
};

export const cartEmpty = async () => {
  try {
    const { data, status } = await axiosNewApi.delete("mobile/carts", {
      withCredentials: true,
    });

    if (status === 200) {
      return data;
    } else {
      throw new Error("Error on clearing the cart");
    }
  } catch (error) {
    handleError(error);
  }
};
